import { OverlayConfig } from '@angular/cdk/overlay';
import { InjectionToken } from '@angular/core';

export const OVERLAY_DEFAULT_CONFIG = new InjectionToken<OverlayConfig>('STANDARD_MODAL_CONFIG');
export const ZOOMED_IMAGE_MODAL_CONFIG = new InjectionToken<OverlayConfig>('ZOOMED_IMAGE_MODAL_CONFIG');
export const OVERLAY_S_CONFIG = new InjectionToken<OverlayConfig>('OVERLAY_S_CONFIG');
export const OVERLAY_L_CONFIG = new InjectionToken<OverlayConfig>('OVERLAY_L_CONFIG');
export const OVERLAY_XL_CONFIG = new InjectionToken<OverlayConfig>('OVERLAY_XL_CONFIG');
export const OVERLAY_REGION_LANGUAGE_SELECTION_CONFIG = new InjectionToken<OverlayConfig>(
    'OVERLAY_REGION_LANGUAGE_SELECTION_CONFIG'
);
export const OVERLAY_QUANTITYCOMBINATION_CONFIG = new InjectionToken<OverlayConfig>('OVERLAY_QUANTITYCOMBINATION_CONFIG');
export const OVERLAY_INCENDIARY_INFO_CONFIG = new InjectionToken<OverlayConfig>('OVERLAY_INCENDIARY_INFO_CONFIG');
export const OVERLAY_FULL_SCREEN_CONFIG = new InjectionToken<OverlayConfig>('OVERLAY_FULL_SCREEN_CONFIG');
